import { Boxes, Eraser, Paintbrush, Crosshair, MonitorPlay } from "lucide-react";
import { SERVICES } from "../data/content";

const ICONS = { rotoscopy: Eraser, prep: Paintbrush, tracking: Crosshair, cgi: Boxes, virtual: MonitorPlay };

export const Services = () => (
  <section id="services" data-testid="services-section" className="py-24 px-4 sm:px-8 lg:px-16 bg-[#0E0E12] border-y border-white/10">
    <div className="max-w-7xl mx-auto">
      <p className="font-mono2 text-xs tracking-[0.35em] text-amber-500/90 mb-4">DISCIPLINES</p>
      <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl tracking-wide text-zinc-50 mb-12">
        FIVE DEPARTMENTS. <span className="text-stroke">ONE OBSESSION.</span>
      </h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {SERVICES.map((s, i) => {
          const Icon = ICONS[s.id];
          return (
            <div key={s.id} data-testid={`service-card-${s.id}`}
              className={`group border border-white/10 bg-[#14141A] p-6 sm:p-8 hover:border-amber-500/50 hover:-translate-y-1 transition duration-300 ${i === 0 ? "sm:col-span-2 lg:col-span-1" : ""}`}>
              <div className="flex items-center justify-between mb-6">
                <Icon className="w-8 h-8 text-amber-500" />
                <span className="font-mono2 text-xs text-zinc-600">0{i + 1}</span>
              </div>
              <h3 className="font-heading text-xl sm:text-2xl font-bold text-zinc-100 group-hover:text-amber-400 transition-colors">{s.title}</h3>
              <p className="mt-3 text-sm text-zinc-400 leading-relaxed">{s.description}</p>
              <ul className="mt-5 space-y-2">
                {s.points.map((pt) => (
                  <li key={pt} className="font-mono2 text-[11px] tracking-[0.15em] text-zinc-500 uppercase">
                    <span className="text-amber-500 mr-2">—</span>{pt}
                  </li>
                ))}
              </ul>
            </div>
          );
        })}
        <div className="border border-amber-500/40 bg-gradient-to-br from-amber-500/10 to-transparent p-6 sm:p-8 flex flex-col justify-between">
          <h3 className="font-heading text-xl sm:text-2xl font-bold text-zinc-100">Something impossible on your shot list?</h3>
          <button data-testid="services-cta-btn"
            onClick={() => document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" })}
            className="mt-6 w-max font-mono2 text-xs tracking-[0.2em] bg-amber-500 text-[#070709] px-6 py-3 font-semibold hover:bg-amber-400 transition-colors">
            TALK TO A SUPERVISOR
          </button>
        </div>
      </div>
    </div>
  </section>
);
